function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a-patient{fill:#e6e6e6;}.b-patient{fill:#a0616a;}.c-patient{fill:#2f2e41;}.d-patient{fill:#575a89;}.e-patient{fill:#d1d1d1;}.f-patient{fill:#3f3b56;}.g-patient{fill:#247dbd;}.h-patient{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("ellipse", {
  className: "a-patient",
  cx: 19.974,
  cy: 4.601,
  rx: 19.974,
  ry: 4.601,
  transform: "translate(167.773 150.507)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "b-patient",
  d: "M708.42,137.969v6.019l3.14,7.851,4.972-8.9v-6.8Z",
  transform: "translate(-520.934 -100.51)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "b-patient",
  d: "M852.577,466.495l-.785,5.757s-1.832,6.281.785,6.281,2.617-6.8,2.617-6.8l.523-3.925Z",
  transform: "translate(-679.092 -382.323)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "b-patient",
  d: "M973.577,463.495l-.785,5.757s-1.832,6.281.785,6.281,2.617-6.8,2.617-6.8l.523-3.926Z",
  transform: "translate(-768.426 -380.108)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "c-patient",
  d: "M869.546,440.867l-1.232.34s-3.217,20.857-3.479,31.849-.785,38.731-.785,38.731h8.374l5.5-47.106,2.617,47.106h8.9s3.664-61.761,1.309-66.733S869.546,440.867,869.546,440.867Z",
  transform: "translate(-688.603 -363.369)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "c-patient",
  d: "M850.5,709.995l-2.355,3.664s-6.542,5.5-.785,5.234,8.113-2.879,8.113-2.879v.785l3.141-1.047-.524-5.757Z",
  transform: "translate(-674.533 -562.1)"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "c-patient",
  d: "M935.163,709.995l2.355,3.664s6.542,5.5.785,5.234-8.113-2.879-8.113-2.879v.785l-3.14-1.047.523-5.757Z",
  transform: "translate(-735.116 -562.1)"
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  className: "b-patient",
  cx: 5.757,
  cy: 5.757,
  r: 5.757,
  transform: "translate(185 27.383)"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "d-patient",
  d: "M706.131,163.531l-2.879-5.895-1.308,3.016-.523,25.908,12.038-26.955-2.094-2.315Z",
  transform: "translate(-515.766 -116.128)"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "e-patient",
  d: "M900.1,313.4l-9.542-6.236s-.664,5.975-6.683,5.451-3.206-5.062-3.206-5.062l-9.617,5.323,3.664,20.412-1.57,11.776s14.132-1.57,17.272.785a13.421,13.421,0,0,0,6.281,2.617l-.523-20.151Z",
  transform: "translate(-693.771 -264.69)"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  className: "e-patient",
  d: "M965.882,330.072l1.81-1.745,1.33.96s1.308,1.57,2.355,6.281.523,25.646.523,25.646l-5.757-.785.262-8.636-2.355-11.515Z",
  transform: "translate(-762.433 -280.314)"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  className: "e-patient",
  d: "M859.592,327.416l-.989-.205-.843.467s-2.355,3.14-2.355,6.019-2.355,27.478-2.355,27.478l5.234,2.355,3.664-18.581Z",
  transform: "translate(-680.481 -279.49)"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  className: "d-patient",
  d: "M975.4,451.011s-5.234-3.14-7.066-1.047,1.047,4.187,1.047,4.187S977.489,457.292,975.4,451.011Z",
  transform: "translate(-765.142 -369.588)"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  className: "d-patient",
  d: "M853.4,457.011s-5.234-3.141-7.066-1.047,1.047,4.187,1.047,4.187S855.489,463.292,853.4,457.011Z",
  transform: "translate(-675.069 -374.017)"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  className: "c-patient",
  d: "M908.4,244.411s1.506-2.879-1.807-3.14c0,0-3.012-1.832-5.421.262,0,0-2.108-.523-2.711,1.047a1.083,1.083,0,0,1,.6-1.308s-2.108-.523-2.108,2.094a8.185,8.185,0,0,0,0,4.972,9.741,9.741,0,0,0,1.2,2.617s-1.485-4.938,2.13-5.2,7.659-2.52,7.96.358.9,3.664.9,3.664S911.858,245.589,908.4,244.411Z",
  transform: "translate(-712.596 -215.492)"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  className: "f-patient",
  d: "M272.113,289.769h-.036c-1.338,0-2.693-.04-4.025-.119l.02-.337c1.327.078,2.674.118,4.006.118h.036Zm4.063-.123-.02-.337c1.341-.08,2.7-.2,4.027-.363l.041.335c-1.338.162-2.7.284-4.046.365ZM264,289.289c-1.34-.16-2.692-.363-4.019-.6l.06-.332c1.32.239,2.665.441,4,.6Zm20.237-.617-.061-.332c1.32-.241,2.651-.526,3.954-.846l.081.327c-1.308.322-2.646.608-3.974.851Zm-28.23-.834c-1.31-.321-2.628-.686-3.916-1.086l.1-.322c1.282.4,2.593.761,3.9,1.081Zm36.118-1.108-.1-.322c1.28-.4,2.565-.843,3.821-1.32l.12.316c-1.262.48-2.554.927-3.84,1.328Zm-43.884-1.3c-1.262-.478-2.527-1-3.761-1.557l.138-.308c1.227.552,2.486,1.073,3.742,1.549Zm51.473-1.579-.139-.308c1.222-.55,2.443-1.147,3.629-1.771l.157.3c-1.193.628-2.42,1.227-3.648,1.781Zm-58.892-1.761c-1.2-.628-2.388-1.3-3.543-2l.175-.288c1.149.7,2.334,1.365,3.525,1.99ZM306.9,280.07l-.175-.288c1.147-.7,2.289-1.434,3.391-2.2l.192.277C309.2,278.629,308.052,279.372,306.9,280.07Zm-73.03-2.193c-1.111-.768-2.213-1.579-3.275-2.411l.209-.266c1.056.828,2.152,1.635,3.258,2.4Zm79.709-2.425-.209-.266c1.059-.831,2.1-1.7,3.1-2.591l.224.252c-1.006.892-2.056,1.768-3.12,2.6Zm-86.107-2.591c-1.01-.9-2.006-1.832-2.96-2.786l.238-.238c.949.948,1.94,1.881,2.945,2.772Zm92.185-2.8-.238-.238c.951-.95,1.884-1.941,2.774-2.944l.252.224c-.894,1.008-1.832,2-2.787,2.959Zm-97.933-2.944c-.9-1.01-1.772-2.059-2.6-3.119l.265-.209c.828,1.054,1.7,2.1,2.591,3.1Zm103.324-3.134-.266-.209c.831-1.059,1.638-2.155,2.4-3.257l.277.192C326.7,261.818,325.884,262.92,325.049,263.984Zm-108.341-3.251c-.768-1.11-1.512-2.256-2.21-3.407l.288-.175c.695,1.146,1.435,2.286,2.2,3.39ZM329.674,257.3l-.288-.175c.7-1.15,1.367-2.335,1.992-3.524l.3.157C331.047,254.95,330.375,256.142,329.674,257.3ZM212.5,253.792c-.628-1.193-1.228-2.42-1.782-3.647l.307-.139c.552,1.221,1.148,2.442,1.773,3.628ZM333.46,250.1l-.308-.138c.554-1.23,1.076-2.488,1.551-3.742l.316.12c-.478,1.26-1,2.525-1.559,3.76Zm-124.3-3.7c-.48-1.261-.927-2.553-1.329-3.84l.322-.1c.4,1.28.845,2.566,1.322,3.821Zm127.188-3.91-.322-.1c.4-1.282.763-2.593,1.083-3.9l.327.08c-.322,1.31-.688,2.627-1.088,3.915Zm-129.61-3.845c-.323-1.309-.61-2.645-.853-3.973l.332-.061c.242,1.322.528,2.651.849,3.953ZM338.284,234.6l-.332-.061c.24-1.32.443-2.665.6-4l.335.04c-.16,1.339-.364,2.692-.6,4.018Zm-133.011-3.946c-.162-1.338-.286-2.7-.366-4.047l.337-.02c.081,1.341.2,2.7.366,4.026Zm133.98-4.12-.337-.02c.079-1.338.12-2.7.12-4.042v-.143h.337v.143C339.374,223.823,339.333,225.189,339.253,226.534Zm-134.135-3.99h-.337v-.071c0-1.327.039-2.669.116-3.99l.337.02c-.077,1.314-.116,2.65-.116,3.97Zm133.789-4.256c-.083-1.342-.207-2.7-.369-4.026l.335-.041c.163,1.336.288,2.7.372,4.046Zm-133.317-3.813-.335-.04c.16-1.34.362-2.692.6-4.019l.332.06C205.951,211.8,205.749,213.142,205.591,214.475Zm132.335-4.21c-.244-1.323-.531-2.653-.853-3.952l.327-.081c.324,1.306.612,2.643.858,3.972Zm-130.9-3.745-.328-.08c.32-1.309.685-2.627,1.084-3.917l.322.1c-.4,1.282-.76,2.594-1.079,3.9Zm128.951-4.1c-.4-1.281-.848-2.566-1.326-3.821l.314-.12c.481,1.26.93,2.552,1.335,3.839Zm-126.555-3.627-.316-.119c.478-1.262,1-2.528,1.555-3.762l.308.138C210.422,196.277,209.9,197.537,209.426,198.793ZM333.1,194.874c-.553-1.221-1.151-2.441-1.777-3.626l.3-.157c.63,1.192,1.23,2.418,1.786,3.645Zm-120.358-3.464-.3-.157c.626-1.194,1.3-2.386,2-3.544l.288.175C214.036,189.036,213.367,190.222,212.744,191.409Zm116.587-3.676c-.7-1.144-1.437-2.284-2.2-3.388l.278-.192c.769,1.109,1.514,2.255,2.213,3.4Zm-112.4-3.249-.278-.192c.766-1.109,1.577-2.211,2.41-3.276l.266.208C218.5,182.285,217.691,183.381,216.929,184.485Zm107.8-3.389c-.831-1.055-1.7-2.1-2.595-3.1l.252-.224c.9,1.007,1.772,2.055,2.607,3.116Zm-102.809-2.979-.253-.224c.894-1.01,1.832-2.007,2.784-2.961l.239.238C223.737,176.12,222.805,177.112,221.916,178.117Zm97.439-3.062c-.953-.949-1.945-1.881-2.948-2.769l.223-.253c1.009.892,2.006,1.828,2.963,2.782Zm-91.728-2.66-.224-.252c1.007-.894,2.056-1.771,3.117-2.606l.209.265C229.674,170.632,228.629,171.5,227.627,172.395Zm85.67-2.7c-1.057-.827-2.154-1.633-3.261-2.4l.192-.278c1.112.767,2.215,1.577,3.277,2.408Zm-79.317-2.3-.192-.277c1.109-.768,2.254-1.512,3.406-2.212l.175.288c-1.146.7-2.286,1.436-3.389,2.2Zm72.656-2.291c-1.152-.7-2.338-1.363-3.527-1.986l.157-.3c1.195.626,2.387,1.3,3.545,2Zm-65.752-1.9-.157-.3c1.192-.628,2.419-1.23,3.646-1.784l.139.307c-1.221.552-2.441,1.149-3.627,1.775Zm58.585-1.854c-1.228-.55-2.486-1.071-3.744-1.544l.119-.316c1.263.477,2.529,1,3.762,1.553Zm-51.23-1.472-.12-.314c1.262-.481,2.554-.929,3.84-1.331l.1.322c-1.281.4-2.566.845-3.822,1.323Zm43.654-1.387c-1.282-.4-2.594-.759-3.9-1.077l.08-.328c1.309.319,2.628.684,3.917,1.082Zm-35.94-1.026-.081-.327c1.31-.324,2.647-.612,3.973-.855l.061.332c-1.319.242-2.649.528-3.952.851Zm28.087-.89c-1.318-.238-2.664-.439-4-.6l.039-.335c1.342.159,2.694.361,4.019.6Zm-20.137-.571-.041-.335c1.337-.163,2.7-.288,4.047-.37l.02.337c-1.341.082-2.7.205-4.026.366Zm12.11-.38c-1.3-.075-2.626-.114-3.935-.114h-.107v-.337h.107c1.315,0,2.645.038,3.954.114Z",
  transform: "translate(-201.902 -152.559)"
});

var _ref19 = /*#__PURE__*/React.createElement("rect", {
  className: "g-patient",
  width: 39.991,
  height: 29.993,
  transform: "translate(98.083 112.597)"
});

var _ref20 = /*#__PURE__*/React.createElement("rect", {
  className: "h-patient",
  width: 29.993,
  height: 2,
  transform: "translate(103.082 120.595)"
});

var _ref21 = /*#__PURE__*/React.createElement("rect", {
  className: "h-patient",
  width: 29.993,
  height: 2,
  transform: "translate(103.082 126.594)"
});

var _ref22 = /*#__PURE__*/React.createElement("rect", {
  className: "h-patient",
  width: 29.993,
  height: 2,
  transform: "translate(103.082 132.593)"
});

var _ref23 = /*#__PURE__*/React.createElement("rect", {
  className: "a-patient",
  width: 27.933,
  height: 20.95,
  transform: "translate(2.094)"
});

var _ref24 = /*#__PURE__*/React.createElement("rect", {
  className: "h-patient",
  width: 20.95,
  height: 1.397,
  transform: "translate(5.585 5.587)"
});

var _ref25 = /*#__PURE__*/React.createElement("rect", {
  className: "h-patient",
  width: 20.95,
  height: 1.397,
  transform: "translate(5.585 9.777)"
});

var _ref26 = /*#__PURE__*/React.createElement("rect", {
  className: "h-patient",
  width: 20.95,
  height: 1.397,
  transform: "translate(5.585 13.967)"
});

var _ref27 = /*#__PURE__*/React.createElement("rect", {
  className: "g-patient",
  width: 27.933,
  height: 20.95,
  transform: "translate(13.965 10.824)"
});

var _ref28 = /*#__PURE__*/React.createElement("rect", {
  className: "h-patient",
  width: 20.95,
  height: 1.397,
  transform: "translate(17.457 16.411)"
});

var _ref29 = /*#__PURE__*/React.createElement("rect", {
  className: "h-patient",
  width: 20.95,
  height: 1.397,
  transform: "translate(17.457 20.601)"
});

var _ref30 = /*#__PURE__*/React.createElement("rect", {
  className: "h-patient",
  width: 20.95,
  height: 1.397,
  transform: "translate(17.457 24.791)"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  className: "a-patient",
  d: "M1106.154-3187.949H1030V-3245h76.154Zm-75.369-56.266v55.48h74.584v-55.48Z",
  transform: "translate(-997.811 3286.349)"
});

var _ref32 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(55.742 55.48)"
}, /*#__PURE__*/React.createElement("circle", {
  className: "g-patient",
  cx: 14.5,
  cy: 14.5,
  r: 14.5,
  transform: "translate(0)"
}), /*#__PURE__*/React.createElement("path", {
  className: "h-patient",
  d: "M431.416,382.3h-4.93v-4.93a1.16,1.16,0,0,0-1.16-1.16h0a1.16,1.16,0,0,0-1.16,1.16v4.93h-4.93a1.16,1.16,0,0,0-1.16,1.16h0a1.16,1.16,0,0,0,1.16,1.16h4.93v4.93a1.16,1.16,0,0,0,1.16,1.16h0a1.16,1.16,0,0,0,1.16-1.16v-4.93h4.93a1.16,1.16,0,0,0,1.16-1.16h0A1.16,1.16,0,0,0,431.416,382.3Z",
  transform: "translate(-410.894 -369.018)"
}));

var _ref33 = /*#__PURE__*/React.createElement("rect", {
  className: "a-patient",
  width: 27.933,
  height: 20.95,
  transform: "translate(0 107.558)"
});

var _ref34 = /*#__PURE__*/React.createElement("rect", {
  className: "h-patient",
  width: 20.95,
  height: 1.397,
  transform: "translate(3.492 113.145)"
});

var _ref35 = /*#__PURE__*/React.createElement("rect", {
  className: "h-patient",
  width: 20.95,
  height: 1.397,
  transform: "translate(3.492 117.334)"
});

var _ref36 = /*#__PURE__*/React.createElement("rect", {
  className: "h-patient",
  width: 20.95,
  height: 1.397,
  transform: "translate(3.492 121.525)"
});

const SvgDashboardAddPatient = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 210.598,
    height: 159.71,
    viewBox: "0 0 210.598 159.71",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDashboardAddPatient, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Dashboard_AddPatient.1c99f099.svg";
export { ForwardRef as ReactComponent };